import { fetchClientApiStep } from '../clientApiStep.helpers';

/** Calls the LocationList step's `list` operation; returns the locations and the whole response. */
// eslint-disable-next-line import/prefer-default-export
export const fetchClientApiLocations = async ({
  api,
  body,
  submissionId,
  token,
}) => {
  const response = await fetchClientApiStep({
    api,
    body,
    submissionId,
    token,
    label: 'Store lookup',
  });
  if (!Array.isArray(response.data))
    throw new Error('Store lookup returned an unexpected response shape');
  return { locations: response.data, response };
};
